import type {
  EventRuleAction,
  EventRuleWorkflow,
} from '../../api/event-rule-policies-api'

export const MAX_NOTIFICATION_RECIPIENTS = 50

export type EventActionDraft = EventRuleAction & { key: string }

export type EventWorkflowDraft = {
  key: string
  workflow: EventRuleWorkflow | null
}

export function actionDraft(action: EventRuleAction): EventActionDraft {
  return { ...action, key: crypto.randomUUID() }
}

export function workflowIdentity(workflow: EventRuleWorkflow): string {
  return workflow.ownerEntityId && workflow.key
    ? `${workflow.ownerEntityId}/${workflow.key}`
    : workflow.definitionId
}

export function workflowDraft(
  workflow: EventRuleWorkflow | null,
): EventWorkflowDraft {
  return { key: crypto.randomUUID(), workflow }
}

export function actionContent(actions: EventActionDraft[]): EventRuleAction[] {
  return actions.map(({ type, recipients }) => ({ type, recipients }))
}

export function newEventRuleId(): string {
  const unixMilliseconds = Date.now().toString(16).padStart(12, '0')
  const randomUuid = crypto.randomUUID()
  return `${unixMilliseconds.slice(0, 8)}-${unixMilliseconds.slice(8)}-7${randomUuid.slice(15, 18)}-${randomUuid.slice(19)}`
}
